import {
  CONTRACT_CATEGORY_SERVICES,
  CONTRACT_REVENUE,
  CORPORATE_LEAD, LINE_ITEMS_APPROVAL_LIST, LINE_ITEMS_APPROVAL_REJECTION, LINE_ITEMS_BY_INVOICE_ID,
  LINE_ITEMS_UPDATE,
  VALET_CONTRACT_INVOICE,
  GET_SERVICES,
  REVENUE_NATURE,
  MANAGEMENT_FEE,
  CAPEX_CONTRACT_INVOICE
} from "./type";

const initalState = {
  corporateLead: [],
  contractRevenueDetails: [],
  contractCatService:[],
  valetContractInvoice:[],
  lineItems:[],
  lineItemsApprovalList:[],
  lineItemsByInvoiceId:[],
  lineItemsApprovalRejectionResponse:[],
  onDemandServicesList:[],
  revenueNature: [],
  managementFeeApplicable: [],
  capexContractInvoice: [],
};

const postSalesReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CORPORATE_LEAD:
      return {
        ...state,
        corporateLead: payload,
      };
    case CONTRACT_REVENUE:
      return {
        ...state,
        contractRevenueDetails: payload,
      };
    case CONTRACT_CATEGORY_SERVICES:
      return {
        ...state,
        contractCatService: payload,
      };
    case VALET_CONTRACT_INVOICE:
      return {
        ...state,
        valetContractInvoice: payload,
      };
    case LINE_ITEMS_UPDATE:
      return {
        ...state,
        lineItems: payload,
      };
    case LINE_ITEMS_APPROVAL_LIST:
      return {
        ...state,
        lineItemsApprovalList: payload,
      };
    case LINE_ITEMS_BY_INVOICE_ID:
      return {
        ...state,
        lineItemsByInvoiceId: payload,
      };
    case LINE_ITEMS_APPROVAL_REJECTION:
      return {
        ...state,
        lineItemsApprovalRejectionResponse: payload,
      };
    case GET_SERVICES:
      return {
        ...state,
        onDemandServicesList: payload,
      };
    case REVENUE_NATURE:
      return {
        ...state,
        revenueNature: payload,
      };
    case MANAGEMENT_FEE:
      return {
        ...state,
        managementFeeApplicable: payload,
      };
    case CAPEX_CONTRACT_INVOICE:
      return {
        ...state,
        capexContractInvoice: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default postSalesReducer;
